
const axios = require('axios')
// ---------
// Actions
// ---------
const SET_USER = 'redux/user/SET_USER'
const LOG_OUT = 'redux/user/LOG_OUT'
const SIGN_IN = 'redux/user/SIGN_IN'
const SIGN_UP = 'redux/user/SIGN_UP'
const SIGN_UP_COMPLETE = 'redux/user/SIGN_UP_COMPLETE'
const SET_LOGIN_ERROR = 'redux/user/SET_LOGIN_ERROR'
const SET_SIGNUP_ERROR = 'redux/user/SET_SIGNUP_ERROR'


// ---------
// Reducer
// ---------

const initialState = {
    id: null,
    username: null,
    email: null,
    isLoggedIn: false,
    isFetching: false,
    jwt: null,
    loginError: null,
    signupError: null
}

const currentUser = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER:
            return {
                ...state,
                id: action.payload.id,
                username: action.payload.username,
                email: action.payload.email,
                isLoggedIn: true,
                isFetching: false,
                jwt: action.payload.jwt,
                loginError: null
            }
        case LOG_OUT:
            return initialState
        case SIGN_IN:
            return {
                ...state,
                isFetching: true,
                loginError: null
            }
        case SIGN_UP:
            return {
                ...state,
                isFetching: true,
                signupError: null
            }
        case SIGN_UP_COMPLETE:
            return {
                ...state,
                isFetching: false,
                signupError: null
            }
        case SET_LOGIN_ERROR:
            return {
                ...state,
                isFetching: false,
                loginError: action.payload.error
            }
        case SET_SIGNUP_ERROR:
            return {
                ...state,
                isFetching: false,
                signupError: action.payload.error
            }
        default:
            return state
    }
}

export default currentUser

// ---------
// Action Creators
// ---------

const setUser = userObj => {
    return {
        type: SET_USER,
        payload: userObj
    }
}

const setLoginError = error => {
    return {
        type: SET_LOGIN_ERROR,
        payload: { error }
    }
}

const setSignupError = error => {
    return {
        type: SET_SIGNUP_ERROR,
        payload: { error }
    }
}

const signIn = (userObj) => dispatch => {
    dispatch({
        type: SIGN_IN
    })

    
    axios.post(process.env.REACT_APP_BACKEND+"/auth/local",{
    // axios.post('http://localhost:1337/auth/local', {
    // axios.post('https://odin-bf0c8.ew.r.appspot.com/auth/local', {
        identifier: userObj.email,
        password: userObj.password,
      })
        .then(function (response) {
            // handle success
            dispatch(setUser({
                id: response.data.user.id,
                username: response.data.user.username,
                phoneNumber: response.data.user.phoneNumber,
                email: response.data.user.email,
                firstName: response.data.user.firstName,
                lastName: response.data.user.lastName,
                odinMember: response.data.user.odinMember,
                subscriptionUntill: response.data.user.subscriptionUntill,
                jwt: response.data.jwt
            }))
        })
        .catch(function (error) {
            let errorMessage = 'Network Error'
            if (error.response) {
                errorMessage = error.response.data.message[0].messages[0].message
                //User does not exist. Sign up for an account
            }
            dispatch(setLoginError(errorMessage))
        })
        .then(function () {
            // always executed
        })
}

const signUp = (userObj) => dispatch => {
    dispatch({
        type: SIGN_UP
    })
    
    axios.post(process.env.REACT_APP_BACKEND+"/auth/local/register",{
    // axios.post('http://localhost:1337/auth/local/register', {
    // axios.post('https://odin-bf0c8.ew.r.appspot.com/auth/local/register', {
        firstName: userObj.firstName,
        lastName: userObj.lastName,
        country: userObj.country,
        phoneNumber: userObj.phone,
        username: userObj.username,
        email: userObj.email,
        password: userObj.password,
        refferal: userObj.ref,
    })
    .then(response => {
        if (response.data.user) {
            dispatch({
                type: SIGN_UP_COMPLETE
            })
            dispatch(signIn(userObj)) //Auto login on successful register
        }
    })
    .catch(error => {
        // Handle error.
        console.log('An error occurred:', error.response);

        let errorMessage = 'Network Error'
        if (error.response) {
            errorMessage = error.response.data.message[0].messages[0].message
            //console.log('An error occurred PROBLEEM:', errorMessage);
        }
        dispatch(setSignupError(errorMessage))
    });
}


const logOut = () => {
    return {
        type: 'USER_LOGGED_OUT' // Pointi i store.js ir isvalo visa State
    }
}

export const userActions = {
    setUser,
    logOut,
    signIn,
    signUp,
    setLoginError,
    setSignupError
}
